import { render } from "./importList.vue?vue&type=template&id=fff121e0&scoped=true"
import script from "./importList.vue?vue&type=script&lang=js"
export * from "./importList.vue?vue&type=script&lang=js"

import "./importList.vue?vue&type=style&index=0&id=fff121e0&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff121e0"]])

export default __exports__